import { render, staticRenderFns } from "./registerList.vue?vue&type=template&id=40d048c4&scoped=true&"
import script from "./registerList.vue?vue&type=script&lang=js&"
export * from "./registerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d048c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d048c4')) {
      api.createRecord('40d048c4', component.options)
    } else {
      api.reload('40d048c4', component.options)
    }
    module.hot.accept("./registerList.vue?vue&type=template&id=40d048c4&scoped=true&", function () {
      api.rerender('40d048c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/registerList.vue"
export default component.exports